import { defineFetch } from 'resift';

const makeUpdateEntitySourceFile = defineFetch({
  displayName: 'Update Entity Source File',
  make: (sourceFileId: string) => ({
    request: (data: any) => ({ http }) =>
      http({
        method: 'PUT',
        route: `/entity-source-files/${sourceFileId}`,
        data,
      }),
  }),
});

export default makeUpdateEntitySourceFile;
